/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 14:47:47                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-17 14:57:34                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * Event: event display component
*/

/* Imports */
import React from "react";
import { Tooltip, Typography } from "@material-tailwind/react";
/***/

/* Components */
import TechnicianDisplay from "../../../../../components/data/technician/TechnicianDisplay";
/***/

/* Styles */
import "./Event.scss";
import CustomerDisplay from "../../../../../components/data/customer/CustomerDisplay";
/***/

/**
* Event: event display component
* @param event - the event to display
* @param className - additional class name 
*/
export default function Event({
  event,
  className
}: {
  event: EasyTech.Time,
  className?: string
}) {
  const content = <>
    {event.workOrder &&
      <>
        <Typography  className={"et-overflow-ellipsis"}>{event.workOrder.ref}</Typography>
        <CustomerDisplay className="et-overflow-ellipsis" customer={event.workOrder.customer} noToolTip hideIndicator />
      </>
    }

    {event.type.label !== "Intervention" &&
      <Typography className={"et-overflow-ellipsis"}>{event.type.label}</Typography>
    }

    {event.technician &&
      <TechnicianDisplay className="et-overflow-ellipsis" technician={event.technician} variant="light" noToolTip />
    }
  </>;

  return (
    <div className={className}>
      {event.id && (
        <>
          <Tooltip content={content}>
            <div className="content">
              {content}
            </div>
          </Tooltip>
        </>
      )}
    </div>
  );
}
/***/
